import englishData from './translations/English';
import frenchData from './translations/French';
import chineseData from './translations/Chinese';
import hindiData from './translations/Hindi';
import spanishData from './translations/Spanish';
import arabicData from './translations/Arabic';
import bengaliData from './translations/Bengali';
import portugueseData from './translations/Portuguese';
import russianData from './translations/Russian';
import japaneseData from './translations/Japanese';
import germanData from './translations/German';
import koreanData from './translations/Korean';
import { TEXT_ITEMS } from "./constants/textItems";
import * as langs from "./constants/languages";

const langDataMap = {
  [ langs.ENGLISH.code ]: englishData,
  [ langs.FRENCH.code ]: frenchData,
  [ langs.CHINESE.code ]: chineseData,
  [ langs.CHINESE.code ]: chineseData,
  [ langs.HINDI.code ]: hindiData,
  [ langs.SPANISH.code ]: spanishData,
  [ langs.ARABIC.code ]: arabicData,
  [ langs.ARABIC.code ]: arabicData,
  [ langs.BENGALI.code ]: bengaliData,
  [ langs.PORTUGUESE.code ]: portugueseData,
  [ langs.RUSSIAN.code ]: russianData,
  [ langs.JAPANESE.code ]: japaneseData,
  [ langs.GERMAN.code ]: germanData,
  [ langs.KOREAN.code ]: koreanData,
};

const _getTextForLang = (lang, text) => {
  return langDataMap[ lang ][ text ] || "";
};

export const getTranslations = () => {
  let _translations = {};

  TEXT_ITEMS.forEach(text => {
      _translations[ text ] =
        langs
          .allLanguageCodes()
          .map(lang => _getTextForLang(lang, text));
    }
  );

  return _translations;
};


// WEBPACK FOOTER //
// ./src/languageData/index.js